<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 本页标题 -->
            <div class="banner_title">Summary Evaluation </div>

            <!-- 企业介绍 -->
            <a-row justify="space-between" class="mg_t">
                <!-- <a-col class="title">
                    About {{PdftStore.fromData.orgInfo?.orgName}}.
                </a-col> -->
                <a-col class="txt">
                    About {{PdftStore.fromData.orgInfo?.orgName}}.{{PdftStore.fromData.orgInfo?.introduction}}
                </a-col>
            </a-row>

            <!-- 评价结果 -->
            <a-row justify="space-between" align="bottom" class="mg_t">
                <a-col :span="4" class="title mgB">
                    Evaluation Result
                </a-col>
                <a-col :span="19">
                    <a-row justify="space-between" align="bottom">
                        <!-- 青铜表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 1 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 1">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                                <!-- {{PdftStore.fromData.orgInfo?.orgName}} -->
                            </div>
                            <div class="fd mg_tx">Bronze</div>
                            <div class="fd font-s">{{'<'+50}}</div>
                            <div class="fd font-s">Fair</div>
                        </a-col>

                        <!-- 白银表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 2 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 2">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                            </div>
                            <div class="fd mg_tx">Silver</div>
                            <div class="fd font-s">51 ~ 60</div>
                            <div class="fd font-s">Good</div>
                        </a-col>

                        <!-- 黄金表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 3 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 3">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                            </div>
                            <div class="fd mg_tx">Gold</div>
                            <div class="fd font-s">61 ~ 70</div>
                            <div class="fd font-s">Excellent</div>
                        </a-col>

                        <!-- 白金表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 4 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 4">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                            </div>
                            <div class="fd mg_tx">Platinum</div>
                            <div class="fd font-s">71 ~ 85</div>
                            <div class="fd font-s">Top Performance </div>
                        </a-col>

                        <!-- 钻石表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 5 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 5">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                            </div>
                            <div class="fd mg_tx">Diamond</div>
                            <div class="fd font-s">86 ~ 100</div>
                            <div class="fd font-s">Highest Performance</div>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>

            <!-- 评价总览 -->
            <a-row justify="space-between" align="middle" class="mg_T">
                <a-col :span="4" class="title">
                    Summary Evaluation:
                </a-col>
                <a-col :span="19" class="txt">
                    {{PdftStore.fromData.questionnaireInfo?.overview}}
                </a-col>
            </a-row>

            <!-- 得分详情 -->
            <a-row class="list" align="middle">

                <!-- 总分 -->
                <a-col class="mg_r">
                    <a-progress type="circle" :width="170" strokeColor="#00baf4" :percent="PdftStore.fromData.questionnaireInfo?.score">
                        <template #format="percent">
                            <span style="color:#013C89;font-size: 72px;">{{ percent }}</span>
                        </template>
                    </a-progress>
                </a-col>

                <!-- 运营排放 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionOperational?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 32px;">{{ percent }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">Operational Emissions</div>
                            <div class="r">
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionOperational?.weightScore}}</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionOperational?.weight}}%</div>
                        </div>
                    </div>
                </a-col>

                <!-- 产业链排放 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionIndustrialChain?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 32px;">{{ percent }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">Industry Chain Emissions</div>
                            <div class="r">
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionIndustrialChain?.weightScore}}</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionIndustrialChain?.weight}}%</div>
                        </div>
                    </div>
                </a-col>

                <!-- 直接减排贡献 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionDirectReduction?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 32px;">{{ percent }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">Contribution to Direct Emission Reduction</div>
                            <div class="r">
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionDirectReduction?.weightScore}}</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionDirectReduction?.weight}}%</div>
                        </div>
                    </div>
                </a-col>

                <!-- 间接减排贡献 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionIndirectReduction?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 32px;">{{ percent }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">Contribution to Indirect Emission Reduction</div>
                            <div class="r">
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionIndirectReduction?.weightScore}}</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionIndirectReduction?.weight}}%</div>
                        </div>
                    </div>
                </a-col>

                <!-- 零碳运营 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionZeroOperation?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 32px;">{{ percent }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">Zero-Carbon Operation </div>
                            <div class="r">
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionZeroOperation?.weightScore}}</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionZeroOperation?.weight}}%</div>
                        </div>
                    </div>
                </a-col>

                <!-- 绿色供应链 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionGreenSupply?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 32px;">{{ percent }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">Green Supply Chain</div>
                            <div class="r">
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionGreenSupply?.weightScore}}</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionGreenSupply?.weight}}%</div>
                        </div>
                    </div>
                </a-col>

                <!-- 承诺与披露 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionPromise?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 32px;">{{ percent }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">Pledges And Disclosure</div>
                            <div class="r">
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionPromise?.weightScore}}</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionPromise?.weight}}%</div>
                        </div>
                    </div>
                </a-col>

                <!-- 零碳投资 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionZeroInvestment?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 32px;">{{ percent }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">Zero-Carbon Investment </div>
                            <div class="r">
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionZeroInvestment?.weightScore}}</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionZeroInvestment?.weight}}%</div>
                        </div>
                    </div>
                </a-col>

            </a-row>

            <!-- 表格和logo -->
            <div class="flexbox">
                <div class="charts">
                    <Echarts v-if="PdftStore.fromData.questionnaireInfo" :name="'page4echarts'"/>
                </div>
                <div class="logobox">
                    <Logos :ids="'arctext2'"/>
                    <div class="logoboxtxt">
                        <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                    </div>
                </div>
            </div>

            <!-- 企业详细 -->
            <div class="txt_box">{{PdftStore.fromData.questionnaireInfo?.evaluate}}</div>
            <div class="txt_box1">{{PdftStore.fromData.questionnaireInfo?.conclusion}}</div>
            

            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">02</div>
        </div>
        
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Logos from '../components/logos.vue'
import Bottoms from '../components/bottoms.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page4',
    components:{Headers, Logos, Bottoms, Echarts},
    setup() {
        const data = reactive({
            num:33,
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .banner_title{
            padding: 96px 0 40px 0;
            font-size: 72px;
            font-weight: 500;
            color: #013C89;
            line-height: 100px;
            border-bottom: 2px solid #013C89;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .mg_t{
            margin-top: 50px;
        }
        .mg_top{
            margin-top: 123px;
        }
        .title{
            font-size: 16px;
            font-weight: 600;
            color: #013C89;
            line-height: 40px;
        }
        .mgB{
            margin-bottom: 45px;
        }
        .mg_T{
            margin-top: 80px;
        }
        .txt{
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            line-height: 24px;
            text-align: justify;
            white-space: normal;
            // word-break: break-all;
            word-wrap: break-word;
        }
        .box{
            width: 169px;
            height: 130px;
            background: #FFFFFF;
            border: 3px solid #F3F3F3;
            border-bottom: 8px solid #D9DADA;
            text-align: center;
            padding-top: 20px;
            .fd{
                font-size: 24px;
                font-weight: 400;
                color: #666666;
                line-height: 30px;
            }
            .font-s{
                font-size: 14px;
                font-weight: 400;
            }
        }
        .heightBox{
            width: 169px;
            height: 195px;
            background: #FFFFFF;
            border: 3px solid #F3F3F3;
            border-bottom: 8px solid #013C89;
            padding: 24px 0;
            text-align: center;
            .logo{
                width: 88px;
                height: 30px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .mg_tx{
                margin-top: 29px;
            }
            .fd{
                font-size: 24px;
                font-weight: 400;
                color: #013C89;
                line-height: 30px;
                text-align: center;
            }
            .font-s{
                font-size: 14px;
                font-weight: 400;
            }
        }
        .list{
            margin-top: 30px;
            width: 100%;
            height: 250px;
            border-top: 1px solid #C5C5C6;
            border-bottom: 1px solid #C5C5C6;
        }
        .mg_r{
            margin-right: 18px;
        }
        .list_r{
            width: 115px;
            margin: 0 9px;
            height: 100%;
            padding: 40px 0;
            text-align: center;
            .list_b{
                padding-top: 12px;
                margin-top: 10px;
                border-top: 2px solid #322523;
                .mg_top_list{
                    padding-top: 12px;
                }
                .flex{
                    display: flex;
                    justify-content: space-between;
                    .t{
                        width: 85px;
                        text-align: left;
                        font-size: 12px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 17px;
                    }
                    .r{
                        width: calc(109px - 85px);
                    }
                    .t_m{
                        font-size: 14px;
                        font-weight: 500;
                        color: #013C89;
                        line-height: 17px;
                    }
                    .t_a{
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 17px;
                    }
                    .s_j{
                        margin-right: 3px;
                        width:0;
                        height:0;
                        border-left:5.5px solid transparent;
                        border-right:5.5px solid transparent;
                        border-bottom:11px solid #013C89;
                        margin: 5px auto 0 auto;
                        
                    }
                    
                }
            }
        }
        .flexbox{
            display: flex;
            align-items: center;
            padding: 30px 0;
            border-bottom: 1px solid #C5C5C6;
            .charts{
                width: 760px;
                height: 440px;
                padding-right: 160px;
                border-right: 1px solid #C5C5C6;
            }
            .logobox{
                margin: 0 auto;
                .img_box{
                    width: 250px;
                    height: 85px;
                    margin: 0;
                    margin-top: 66px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
        .txt_box{
            // margin-top: 56px;
            margin: 10px 0;
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            text-align: justify;
            line-height: 24px;
            white-space: normal;
            // word-break: break-all;
            word-wrap: break-word;
            // margin-bottom: 40px;
        }
        .txt_box1{
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
        }
    }
    
}
.nametxt{
    max-width: 88px;
    max-height: 30px;
    margin: 0 auto;
    text-align: center;
    img{
        height: 30px;
        width: auto;
    }
}
.logoboxtxt{
    max-width: 240px;
    max-height: 84px;
    min-width: 240px;
    min-height: 84px;
    width: 240px;
    height: 84px;
    text-align: center;
    margin: 60px auto 0 auto;
    img{
        width: auto;
        height: 84px;
    }
}
</style>